export default __webpack_public_path__ + "static/media/side_notification.f399d572.svg";